import environment from "@/config/environment";
import { type DefaultEventsMap } from "@socket.io/component-emitter";
import EventBus from "js-event-bus";
import _ from "lodash";
import { useEffect } from "react";
import { io, Socket } from "socket.io-client";

let ready = false;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let joined: any[] = [];
let socket: Socket<DefaultEventsMap, DefaultEventsMap> | null = null;

export const publicWebsocketBus = new EventBus();

publicWebsocketBus.on("join", (event) => {
  console.log("websockets join", event);
  if (!ready) joined.push(event);
});

export const usePublicWebSockets = () => {
  useEffect(() => {
    const endpoint = environment.server
      .replace(/\/$/, "")
      .replace(/^http/, "ws");
    socket = io(endpoint + "/websockets", {
      reconnectionDelayMax: 10000,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 5000,
    });

    socket.on("message", (event) => {
      publicWebsocketBus.emit(event.room, null, event);
    });

    socket.on("connect", () => {
      ready = true;
      console.log("🟢 Public websockets connected");

      publicWebsocketBus.detach("join"); //Detach buffer
      publicWebsocketBus.on("join", (event) => {
        joined.push(event);
        if (socket) socket.emit("join", { room: event.room });
      });

      joined = _.uniqBy(joined, "room");
      console.log(
        `🔄 Re-joining ${joined.length} room(s):`,
        joined.map((j) => j.room),
      );
      joined.forEach(
        (event) => socket && socket.emit("join", { room: event.room }),
      );
    });

    socket.on("disconnect", (reason) => {
      ready = false;
      console.log("🔴 Public websockets disconnected:", reason);

      // Reset handler to buffer mode during disconnect
      publicWebsocketBus.detach("join");
      publicWebsocketBus.on("join", (event) => {
        console.log("⏸️  Buffering join during disconnect:", event.room);
        if (!joined.some((j) => j.room === event.room)) {
          joined.push(event);
        }
      });
    });

    socket.on("reconnect", (attemptNumber) => {
      console.log(
        `🔄 Public websockets reconnected after ${attemptNumber} attempt(s)`,
      );
    });

    socket.on("reconnect_attempt", (attemptNumber) => {
      console.log(`🔄 Public websockets reconnect attempt #${attemptNumber}`);
    });

    socket.on("reconnect_error", (error) => {
      console.error("❌ Public websockets reconnect error:", error.message);
    });

    socket.on("connect_error", (error) => {
      console.error("❌ Public websockets connect error:", error.message);
    });

    return () => {
      if (socket) socket.close();
      socket = null;
    };
  }, []);
};
